import { useSearchParams } from 'react-router-dom'
import { Tab } from 'react-bootstrap'
import React from 'react'
import type { TabWithSearchParamsProps } from './index'

export type TabContainerWithSearchParamsProps = TabWithSearchParamsProps & {
  /**
   * Every key the container may select. A URL value outside this list falls back to `defaultActiveKey`.
   * Spelled out because the panes are not direct children here (a `SideNavigation` sits between), so
   * their `eventKey`s cannot be scanned the way `TabWithSearchParams` does.
   */
  tabKeys?: string[]
}

export const TabContainerWithSearchParams = ({
  children,
  defaultActiveKey,
  tabName,
  tabKeys,
  ...props
}: TabContainerWithSearchParamsProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  tabName = tabName ?? 'tab'

  const paramValue = searchParams.get(tabName)
  const isSelectable = paramValue && (!tabKeys || tabKeys.includes(paramValue))

  return (
    <Tab.Container
      {...props}
      activeKey={isSelectable ? paramValue : defaultActiveKey}
      defaultActiveKey={defaultActiveKey}
      onSelect={(k) =>
        setSearchParams((searchParams) => {
          searchParams.set(tabName, k)
          return searchParams
        })
      }
    >
      {children}
    </Tab.Container>
  )
}
